// Mono ticker band. Content is duplicated once so the loop is seamless.
export const Marquee = ({ items = [] }) => {
  const row = (hidden) => (
    <ul className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
      {items.map((t, i) => (
        <li key={`${t}-${i}`} className="flex items-center">
          <span className="font-mono text-[12px] text-accent">{String(i + 1).padStart(2, "0")}</span>
          <span className="whitespace-nowrap pl-3 pr-10 font-display text-2xl font-semibold tracking-[-0.03em] text-ink sm:pr-14 sm:text-3xl">{t}</span>
          <span className="cross mr-10 text-muted sm:mr-14" />
        </li>
      ))}
    </ul>
  );
  return (
    <section className="overflow-hidden border-y border-line bg-surface/70 py-6 sm:py-8" aria-label="Focus areas and regions" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
        {row(false)}
        {row(true)}
      </div>
    </section>
  );
};
